// John Eldhose 20190429
import React, { Component } from 'react';
import { Button, CircularProgress, Divider, Grid, Typography } from '@material-ui/core';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { ChevronLeft, Send } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import DemoTab from '../lib/DemoTab';
import { loadLoginPage, resetLoginPage } from '../lib/LoginPage';
import ProfileAddress from '../lib/ProfileAddress';
import Dealers from '../lib/Dealers';
import { postData } from '../lib/api';

class Demo extends Component {

  state = {
    tab: '',
    demo: {},
    profile: {},
    address: {},
    sendBy: '',
    sendStatus: 0,
    dealer: {}
  }
  handleDemo = (tab, prod) => {
    var sendBy = (prod.downloadsite === null) ? 'CD' : (
      (prod.cd_available !== '1') ? 'EMAIL' : ''
    );
    this.setState({
      tab: tab, demo: prod, profile: {}, address: {}, sendBy: sendBy,
      sendStatus: 0
    });
  }
  componentWillMount() {
    var page = loadLoginPage();
    if(page !== null && typeof page.opts === 'object' && page.opts.length === 2)
      this.handleDemo(page.opts[0], page.opts[1]);
    resetLoginPage();
  }
  ProfileAddressBack = () => {
    this.setState({ demo: {}, profile: {}, address: {} });
  }
  ProfileAddressContinue = (profile, address) => {
    this.setState({ profile: profile, address: address });
  }
  handleSend = () => {
    postData('demoSend', { demo: [this.state.demo], sendBy: this.state.sendBy, address: this.state.address, dealer: this.state.dealer})
      .then((demo) => {
        this.setState({
          sendStatus: ((demo['status'] === 'true') ? demo['send'] : 2)
        });
      })
      .catch((err) => { console.log(err); })
  }
  content = () => {
    if(Object.keys(this.state.demo).length > 0) {
      if(this.state.sendStatus < 1) {
        if(
          Object.keys(this.state.profile).length < 1 ||
          Object.keys(this.state.address).length < 1
        )
          return (
            <div>
              <Typography variant='title'>
                <b>{this.state.demo['pname']}</b>
              </Typography>
              <Divider style={{ margin: '20px 0px' }} />
              <ProfileAddress
                Back={this.ProfileAddressBack}
                Continue={this.ProfileAddressContinue}
                DefaultFirst={true}
                NoBillTo={true}
              />
            </div>
          );
        else
          return (
            <div>
              <Typography variant='title'>
                <b>{this.state.demo['pname']}</b>
              </Typography>
              <Divider style={{ margin: '20px 0px' }} />
              <FormControl>
                <RadioGroup
                  value={this.state.sendBy}
                  onChange={(e) => this.setState({ sendBy: e.target.value })}
                >
                  {(this.state.demo.downloadsite !== null) ?
                    (
                      <FormControlLabel
                        value='EMAIL'
                        control={
                          <Radio
                            color='primary'
                            checked={this.state.sendBy === 'EMAIL'}
                          />
                        }
                        label={
                          <FormattedMessage
                            id='Email me download link and demo serial number'
                            defaultMessage='Email me download link and demo serial number'
                          />
                        }
                      />
                    ) : ''
                  }
                  {(
                    this.state.demo.downloadsite === null || this.state.demo.cd_available === '1'
                  ) ?
                    (<FormControlLabel
                      value="CD"
                      control={
                        <Radio
                          color='primary'
                          checked={this.state.sendBy === 'CD'}
                        />
                      }
                      label={
                        (this.state.tab === 'Hardware') ?
                        <FormattedMessage
                          id='Contact me to schedule a demo with a Carlson Representative'
                          defaultMessage='Contact me to schedule a demo with a Carlson Representative'
                        /> :
                        <FormattedMessage
                          id='Ship me Media (it may take up to 10 days)'
                          defaultMessage='Ship me Media (it may take up to 10 days)'
                        />
                      }
                    />) : ''
                  }
                </RadioGroup>
              </FormControl>
              <Grid container>
                <Grid item xs={1} sm={1} md={2} lg={2} xl={2} />
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                <Dealers
                  required={false}
                  handleDealer={(d) => this.setState({ dealer: d })}
                />
                </Grid>
                <Grid item xs={1} sm={1} md={2} lg={2} xl={2} />
                <Grid item style={{ height: '40px' }} xs={12}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Button
                    color='primary'
                    onClick={() => this.setState(
                      { profile: {}, address: {}, sendBy: '' }
                    )}
                  >
                    <ChevronLeft />&nbsp;
                    <FormattedMessage id='Back' defaultMessage='Back' />
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Button
                    variant='raised'
                    color='primary'
                    onClick={this.handleSend}
                    disabled={(this.state.sendBy === '')}
                  >
                    <FormattedMessage
                      id='Send Request'
                      defaultMessage='Send Request'
                    />
                    &nbsp;<Send />
                  </Button>
                </Grid>
              </Grid>
            </div>
          );
      }
      else if (this.state.sendStatus === 1)
        return <CircularProgress />;
      else if (this.state.sendStatus === 2)
        return (
          <div>
            <Typography variant='body1' style={{ textAlign: 'left' }}>
              <FormattedMessage
                id='Failed to send the information requested. Please contact us at one of the following contacts'
                defaultMessage='Failed to send the information requested. Please contact us at one of the following contacts'
              />:
            </Typography>
            <Typography variant='body1'>
              <FormattedMessage id='Email' defaultMessage='Email' />:
              <a href='mailto:demo_request@carlsonsw.com'>
                <FormattedMessage
                  id='Demo Request Contact'
                  defaultMessage='Demo Request Contact'
                />
              </a><br />
              <FormattedMessage id='Phone' defaultMessage='Phone' />: 606-564-5028<br />
              <FormattedMessage id='Fax' defaultMessage='Fax' />: 606-564-6422
            </Typography>
          </div>
        );
      else if (this.state.sendStatus === 3)
        return (
          <div>
            <Typography variant='body1' style={{ textAlign: 'justify' }}>
              <FormattedMessage id='Thank you for your interest in Carlson Software. Your information has been submitted.' defaultMessage='Thank you for your interest in Carlson Software. Your information has been submitted.' /><br />
              <FormattedMessage id='If you do not receive correspondence from your request soon, please contact us at one of the following contacts' defaultMessage='If you do not receive correspondence from your request soon, please contact us at one of the following contacts' />:<br />
            </Typography>
            <br />
            <Typography variant='body1'>
              <FormattedMessage id='Email' defaultMessage='Email' />:
              <a href='mailto:demo_request@carlsonsw.com'>
                <FormattedMessage
                  id='Demo Request Contact'
                  defaultMessage='Demo Request Contact'
                />
              </a><br />
              <FormattedMessage id='Phone' defaultMessage='Phone' />: 606-564-5028<br />
              <FormattedMessage id='Fax' defaultMessage='Fax' />: 606-564-6422
            </Typography>
            <Divider style={{ margin: '10px 0px' }} />
            <Typography variant='body1'>
              Return to the <a href="http://www.carlsonsw.com">Carlson Website</a>
            </Typography>
          </div>
        );
    }
    else
      return <DemoTab handleDemo={this.handleDemo} />
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>
            <FormattedMessage
              id='Demo Carlson Products'
              defaultMessage='Demo Carlson Products' 
            />
          </font></center>
        </Typography>
        <p />
        {this.content()}
      </div>
    );
  }
}

export default Demo;



// WEBPACK FOOTER //
// ./src/components/home/Demo.js